// react-router components


// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import VeroNavbar from "components/VeroNavbar";
import VeroFooter from "components/VeroFooter";

// Sections
import Counters from "pages/home/sections/Counters";
import Services from "pages/home/sections/Services";
import ClientsAndTestimonials from "pages/home/sections/ClientsAndTestimonials";

// Routes
import routes from "routes";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function Home() {
  return (
    <MKBox id="top">
      <VeroNavbar routes={routes} />
      <MKBox
        minHeight="40vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.7),
              rgba(gradients.dark.state, 0.7)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={8} justifyContent="center" mx="auto">
            <MKTypography
              variant="h2"
              color="white"
              mb={1}
              textAlign="center"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["2xl"],
                },
              })}
            >
              Vero is Latin for &quot;It Is True&quot;
            </MKTypography>
            <MKTypography
              variant="body2"
              color="white"
              textAlign="center"
              px={{ xs: 2, lg: 8 }}
              mt={1}
              mb={3}
            >
              We&apos;re a software services company focused on one thing: programming, AI, and
              data &mdash; built by a small team businesses actually get to talk to.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          mx: { xs: 2, lg: 3 },
          mt: -6,
          mb: 4,
          backgroundColor: ({ palette: { surface }, functions: { rgba } }) =>
            rgba(surface.main, 0.85),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <Divider />
        <Services />
        <Divider />
        <ClientsAndTestimonials />
      </Card>
      <VeroFooter />
    </MKBox>
  );
}

export default Home;
